import React from "react"
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom"
import { Box, CircularProgress, Typography } from "@mui/material"
import { BoxFC } from "components/BoxCustom"
import useLiff from "./useLiff"
import LiffRegister from "./LiffRegister"
import LiffUpload from "./LiffUpload"

/**
 * Entry for the LINE mini-app used by subcontract drivers (see docs/subcontract-driver-plan.md §6).
 * Both rich-menu buttons land here:  /liff/register  and  /liff/upload.
 * No Emily session — identity is the LINE ID token handed to every API call.
 */
const LiffLayout = () => {
  const { path } = useRouteMatch()
  const liff = useLiff()

  if (liff.status === "loading") {
    return (
      <BoxFC alignItems="center" justifyContent="center" minHeight="100vh" gap={2}>
        <CircularProgress />
        <Typography color="text.secondary">กำลังเชื่อมต่อ LINE...</Typography>
      </BoxFC>
    )
  }
  if (liff.status === "error") {
    return (
      <BoxFC alignItems="center" justifyContent="center" minHeight="100vh" gap={1} px={3}>
        <Typography variant="h6" color="error">เปิดหน้านี้ไม่สำเร็จ</Typography>
        <Typography color="text.secondary" textAlign="center">{liff.error}</Typography>
        <Typography variant="body2" color="text.secondary" textAlign="center">กรุณาเปิดจากเมนูใน LINE อีกครั้ง</Typography>
      </BoxFC>
    )
  }

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f4f6f8", pb: 4 }}>
      <Switch>
        <Route path={`${path}/register`}><LiffRegister liff={liff} /></Route>
        <Route path={`${path}/upload`}>
          {liff.profile?.IsReg ? <LiffUpload liff={liff} /> : <Redirect to={`${path}/register`} />}
        </Route>
        <Route path="*"><Redirect to={liff.profile?.IsReg ? `${path}/upload` : `${path}/register`} /></Route>
      </Switch>
    </Box>
  )
}

export default LiffLayout
